<template>
  <v-container class="pa-0">
    <ferro-menu-item
        v-if="showDashboardIcon"
        title="Dashboard" icon="mdi-view-dashboard"
        :route-name="ROUTES.DASHBOARD"
    />
    <ferro-menu-item
      v-for="smi in sideMenuItems"
      :key="smi.type"
      :id="smi.id"
      :title="smi.title"
      :component-icon="smi.componentIcon"
      :icon="smi.icon"
      :route-name="smi.routeName"
    />
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import * as routes from '@/router/route-names'
import FerroMenuItem from '@/components/sidemenu/FerroMenuItem'
import { options, sideMenuItems } from '@/components/sidemenu/side-menu-options'

export default {
  components: { FerroMenuItem },
  created() {
    this.ROUTES = routes
  },
  computed: {
    ...mapGetters({
      areFeaturesLoaded: 'areFeaturesLoaded',
      getActiveAccount: 'getActiveAccount',
      sideMenuOptions: 'feature_side_menu_options',
      quoteFlowName: 'quoteFlowName',
      getActiveAccountBrokerageRelationship: 'getActiveAccountBrokerageRelationship',
      getSideMenuNameOverride: 'getSideMenuNameOverride',
    }),
    isProspectiveClient() {
      return 'PROSPECT' === this.getActiveAccountBrokerageRelationship
    },
    showDashboardIcon() {
      return this.areFeaturesLoaded
    },
    sideMenuItems() {
      if (!this.areFeaturesLoaded) {
        return []
      }
      if (this.sideMenuOptions == null) {
        return []
      }
      return this.sideMenuOptions
        .map(smo => {
          const smi = {...sideMenuItems[smo]}
          const overrideName = this.getSideMenuNameOverride(smo)
          if (overrideName) {
            smi.title = overrideName
          }
          // TODO: Future Release - Remove this now that we have a fuller solution
          if (smo === options.RENEWAL_DASHBOARD) {
            smi.title = this.quoteFlowName
          }
          return smi
        })
        .filter(smo => {
          if (this.isProspectiveClient && smo.clientOnly) {
            return false
          }
          return true
        })
    },
    accountCode() {
      if (this.getActiveAccount) {
        return this.getActiveAccount.accountCode
      }
      return undefined
    },
  },
  methods: {
    ...mapActions({}),
  },
}
</script>
